var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FontAwesomeIcon',{staticClass:"title-poster-ribbon",class:[`title-poster-ribbon--${_vm.position}`, { 'title-poster-ribbon--active': _vm.isInWatchlist }],attrs:{"icon":"bookmark"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggleInWatchList(_vm.isInWatchlist)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }